<template>
  <v-snackbar
    v-model="showSnackbar"
    :color="colorComputed"
    :timeout="timer"
    location="top right"
  >
    <v-icon left>
      {{ iconComputed }}
    </v-icon>
    {{ message }}
  </v-snackbar>
</template>

<script>
import { appState } from '@/shared/appState';
import emitter from '@/shared/services/emitter';

export default {
  name: 'AppToast',
  data() {
    return {
      showSnackbar: false,
      message: '',
      color: '',
      icon: '',
      timer: 0,
    };
  },
  computed: {
    iconComputed() {
      return this.icon || this.color === 'success' ? 'mdi-check' : 'mdi-alert-circle ';
    },
    colorComputed() {
      return this.color === 'success'
        ? 'var(--toastSuccessBackground)'
        : this.color === 'error'
          ? 'var(--toastDangerBackground)'
          : this.color;
    },
  },
  created() {
    emitter.on('createToast', data => {
      if (!appState.value.isOffline) {
        this.show(data);
      }
    });
  },
  methods: {
    show(data) {
      this.message = data.message || '';
      this.color = data.color || 'success';
      this.timer = data.timer || 3000;
      this.icon = data.icon;
      this.showSnackbar = true;
    },
  },
};
</script>
